<template>
<div class="row col-sm-12">
    <table>
        <tr>
            <td class="align-middle px-2">
                <label>INSPECCIÓN</label>
            </td>
            <td>
                <button
                    class="btn btn-success"
                    @click.prevent="
                        openTab(`/common/pdf?accAppId=${1527}`)
                    "
                    >
                    Ver solicitud
                </button>
            </td>
        </tr>
    </table> 
          
</div>
    
</template>

<script>
export default {
    data() {
        return {
        preloader: false,
        inputs: {},
        };
    },
    created() {
    },
    methods: {
        openTab(path) {
            window.open(path, "_blank").focus();
        },
    }

}
</script>

<style>

</style>